import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from 'react';
import { ThemeUIProvider, useThemeUI } from 'theme-ui';
import { fontStyles, } from './typography';
import { colors } from './colors';
export const BREAKPOINTS = ['576px', '768px', '992px', '1200px', '1400px'];
export var BOX_SHADOW;
(function (BOX_SHADOW) {
    BOX_SHADOW["NORMAL"] = "0 0 8px #dfdfdf";
    BOX_SHADOW["EMPHASIZED"] = "0 0 12px #d3d3d3";
    BOX_SHADOW["INVERTED"] = "0 0 8px #767676";
})(BOX_SHADOW || (BOX_SHADOW = {}));
export var Z_INDEX;
(function (Z_INDEX) {
    Z_INDEX[Z_INDEX["NORMAL"] = 1] = "NORMAL";
    Z_INDEX[Z_INDEX["ELEVATED"] = 2] = "ELEVATED";
    Z_INDEX[Z_INDEX["DIALOG"] = 3] = "DIALOG";
    Z_INDEX[Z_INDEX["MODAL"] = 4] = "MODAL";
})(Z_INDEX || (Z_INDEX = {}));
export const SPACING = [
    '0rem',
    '0.25rem',
    '0.5rem',
    '0.75rem',
    '1rem',
    '1.5rem',
    '2rem',
    '3rem',
    '4rem',
];
export const theme = Object.assign(Object.assign({}, fontStyles), { colors, space: SPACING, boxShadow: BOX_SHADOW, breakpoints: BREAKPOINTS, zIndex: Z_INDEX });
export const themeV2 = Object.assign(Object.assign({}, fontStyles), { colors, space: SPACING, boxShadow: BOX_SHADOW, breakpoints: BREAKPOINTS, zIndex: Z_INDEX });
export const useTheme = () => {
    const { theme } = useThemeUI();
    return theme;
};
export const ThemeProvider = ({ children }) => {
    return _jsx(ThemeUIProvider, Object.assign({ theme: theme }, { children: children }));
};
const ThemeV2Context = createContext(themeV2);
export const useThemeV2 = () => {
    const context = useContext(ThemeV2Context);
    if (!context) {
        throw new Error('useThemeV2 must be used within a ThemeProviderV2');
    }
    return context;
};
export const ThemeProviderV2 = ({ children }) => {
    const value = useMemo(() => themeV2, []);
    return (_jsx(ThemeV2Context.Provider, Object.assign({ value: value }, { children: children })));
};
